export default "__VITE_ASSET__CZoMb_ex__"